export default __webpack_public_path__ + "static/cabin-tiny-home-2-people-3-9e8595a38e20c3651f92b671d7ec4567.jpg";